export default {
  try: 'Try(NL)',
  recommendation: 'recommendation(NL)',
  noProducts: 'Geen producten',
};
